// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1s_G7","title":"Images90_title__g9ph-","images":"Images90_images__1_Z21"};